/**
 * Finances tab for customer: contains listing for statements and charges for the given customer.
*/
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { FormControl, Grid, MenuItem, Paper, Select, Typography
} from '@mui/material';

import AppBindStyles from '../../AppBindStyles';

import Charges from './Charges';
import CustomerStatement from './CustomerStatement';
import CustomerProjectStatementWrapper from './CustomerProjectStatementWrapper';
import ResellerInvoiceSummary from './ResellerInvoiceSummary';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    // flexGrow: 1,
    // marginTop: 10,
    //backgroundColor: theme.palette.primary.light,
  },
 
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    // color: theme.palette.text.secondary,
    marginTop: 16,
  },
  selectField: {
      marginRight: theme.spacing(1),
  }

 
});

class Customer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: 0
    }
  }

  componentDidMount() {
    // Is there something in local storage? We save this in case user uses back button from a linked page.
    let theValue = 0;
    let tabval = localStorage.getItem('customerFinanceTabVal');
    if (tabval !== null) {
      theValue = parseInt(tabval, 10);
      this.setState({value: theValue});
    }
  }

  handleSelectChange = (event) => {
    localStorage.setItem('customerFinanceTabVal', event.target.value);
    this.setState({ value: event.target.value });
  }

  render() {
    const { isAuthenticated, isAuthenticatedAppBind, isAuthenticatedReseller, needAssent } = this.props.auth;
    const classes = this.props.classes;

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller() || isAuthenticatedAppBind()) {
      return (
        <div className={classes.root}>
          <Grid item >
            <Grid container spacing={2} direction="row" alignItems="center">
              <Grid item>
                <Typography variant="body1" style={AppBindStyles.boldLabel}>Select report:</Typography>
              </Grid>
              <Grid>
                <FormControl className={classes.selectField} style={{marginLeft: '16px', marginTop: '16px'}}>
                  <Select
                    value={this.state.value}
                    onChange={this.handleSelectChange}
                  >
                    <MenuItem value={0}>Monthly statement</MenuItem>
                    <MenuItem value={1}>Subscription charges</MenuItem>
                    <MenuItem value={2}>Bills</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>      
          </Grid>
          <Grid item xs={12}>
            {this.state.value === 1 &&
            <Paper className={classes.paper}>
                <Charges customerAccountId={this.props.customerAccountId}
                          pAccountId={abEnvironment.getUserAttribute('a_id')}
                          auth={this.props.auth}
                          history={this.props.history}/>
            </Paper>}
            {/* PROJECT TODO: when we convert to projects, this will be
                this.state.value === 0 && this.props.projects.length === 0 */}
            {this.state.value === 0 && this.props.projects.length >= 0 &&
            <CustomerStatement 
              customerAccountId={this.props.customerAccountId}
              pAccountId={abEnvironment.getUserAttribute('a_id')}
              fbClientId={this.props.fbClientId}
              fbLogo={this.props.fbLogo}
              auth={this.props.auth}
              history={this.props.history}
            />}
            {/* PROJECT TODO: when we convert to projects, this will not change */}
            {this.state.value === 0 && this.props.projects.length > 0 &&
            <CustomerProjectStatementWrapper
              customerAccountId={this.props.customerAccountId}
              pAccountId={abEnvironment.getUserAttribute('a_id')}
              projects={this.props.projects}
              fbClientId={this.props.fbClientId}
              fbLogo={this.props.fbLogo}
              auth={this.props.auth}
              history={this.props.history}
            />}
            {this.state.value === 2 &&
            <ResellerInvoiceSummary 
              customerAccountId={this.props.customerAccountId}
              auth={this.props.auth}
              history={this.props.history}
            />}
          </Grid>
        </div>
      );
    } else {
      return (
        <h4>
          You do not have access to this page.
        </h4>
      );
    }
  }


}

Customer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(Customer);
